import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axiosInstance from "../../../api/axiosInstance";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import TagRoundedIcon from '@mui/icons-material/TagRounded';
import ApartmentRoundedIcon from '@mui/icons-material/ApartmentRounded';
import ColorizeRoundedIcon from '@mui/icons-material/ColorizeRounded';
import Filter1RoundedIcon from '@mui/icons-material/Filter1Rounded';
import Filter2RoundedIcon from '@mui/icons-material/Filter2Rounded';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import EditModal from "../../../components/editModal/editModal";
import useEntity from "../../../api/useEntity";
import moment from 'moment';
import "./tennants.scss"

const Tennants = () => {
    const [items, setItems] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);

    const fetchData = useCallback(async () => {
        try {
            const res = await axiosInstance.get("/data/tennants");
            setItems(res.data);
        } catch (err) {
            console.error(err);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);


    const { item, setItem, isLoading, save } = useEntity({
        endpoint: "data/tennants",
        selectedItem,
        onSuccess: () => {
            fetchData();
            setSelectedItem(null);
        }
    });

    return (
        <div className="tennants">
            <div className="tableWrapper">
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            <th>Nr.</th>
                            <th>Firma</th>
                            <th>Host</th>
                            <th>Erstellt am</th>
                            <th className="options"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((i) => (
                            <tr key={i.id}>
                                <td><img src={`/assets/branding/${i.logoNav}`} alt="Logo" height="30px" width="30px" /></td>
                                <td>{i.id}</td>
                                <td>{i.company}</td>
                                <td><Link to={`https://${i.host}`} target="blank">{i.host}</Link></td>
                                <td>{moment(i.createdAt).calendar()}</td>
                                <td className="options">
                                    <div className="controls">
                                        <EditOutlinedIcon onClick={() => setSelectedItem(i.id)} />
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {selectedItem !== null && (
                <EditModal
                    title="Tennant"
                    isLoading={isLoading}
                    item={item}
                    onClose={() => setSelectedItem(null)}
                    onSave={save}
                >
                    <div className="group">
                        <TagRoundedIcon />
                        <input
                            type="text"
                            value={item.id || ""}
                            placeholder="ID"
                            disabled
                            onChange={(e) =>
                                setItem(prev => ({
                                    ...prev,
                                    id: e.target.value
                                }))
                            }
                        />
                    </div>
                    <div className="group">
                        <ApartmentRoundedIcon />
                        <input
                            type="text"
                            value={item.company || ""}
                            placeholder="Firmenname"
                            onChange={(e) =>
                                setItem(prev => ({
                                    ...prev,
                                    company: e.target.value
                                }))
                            }
                        />
                    </div>
                    <div className="group">
                        <LinkOutlinedIcon />
                        <input
                            type="url"
                            value={item.host || ""}
                            placeholder="Host"
                            onChange={(e) =>
                                setItem(prev => ({
                                    ...prev,
                                    host: e.target.value
                                }))
                            }
                        />
                    </div>
                    <div className="group">
                        <ColorizeRoundedIcon />
                        <div className="box">
                            <input
                                id="colorPicker"
                                type="color"
                                value={item.accentColor || ""}
                                placeholder="Akzentfarbe"
                                onChange={(e) =>
                                    setItem(prev => ({
                                        ...prev,
                                        accentColor: e.target.value
                                    }))
                                }
                            />
                            <label for="colorPicker">Akzentfarbe</label>
                        </div>
                    </div>
                    <div className="group">
                        <Filter1RoundedIcon />
                        <div className="box vertical">
                            <img src={"/assets/branding/" + item.logo} alt="Logo" height="70px" />
                            <input
                                type="file"
                                alt="Logo"
                                placeholder="Logo"
                                onChange={(e) =>
                                    setItem(prev => ({
                                        ...prev,
                                        logo: e.target.value
                                    }))
                                }
                            />
                        </div>
                    </div>
                    <div className="group">
                        <Filter2RoundedIcon />
                        <div className="box vertical">
                            <img src={"/assets/branding/" + item.logoNav} alt="Logo" height="70px" />
                            <input
                                type="file"
                                alt="Logo"
                                placeholder="Logo Nav"
                                onChange={(e) =>
                                    setItem(prev => ({
                                        ...prev,
                                        logoNav: e.target.value
                                    }))
                                }
                            />
                        </div>
                    </div>
                    <div className="bottom">
                        <div className="left">
                            <button type="submit">Speichern</button>
                        </div>
                    </div>
                </EditModal>
            )}
        </div>
    )
};

export default Tennants